module.exports = __webpack_public_path__ + "img/l3.7dca2fce.png";